import { createFileRoute } from '@tanstack/react-router';
import { PhotoViewerPage } from '@/modules/photo-viewer/photo-viewer-page';

export const Route = createFileRoute('/_auth/photo-viewer')({
  component: PhotoViewerPage,
});
